import { render, staticRenderFns } from "./FeeApplicationResult.vue?vue&type=template&id=70280a56&scoped=true"
import script from "./FeeApplicationResult.vue?vue&type=script&lang=js"
export * from "./FeeApplicationResult.vue?vue&type=script&lang=js"
import style0 from "./FeeApplicationResult.vue?vue&type=style&index=0&id=70280a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70280a56",
  null
  
)

export default component.exports